import { AdminBookingUpdate } from "@tuteria/shared-lib/src/_new_/features/booking-updates/admin/BookingUpdate";
import { StudentForm } from "@tuteria/shared-lib/src/_new_/features/booking-updates/types";
import ThemeProvider from "@tuteria/shared-lib/src/bootstrap";
import ReactDOM from "@tuteria/shared-lib/src/react-dom";

export function unMountLinkRequestModal(id: string) {
  ReactDOM.unmountComponentAtNode(document.getElementById(id));
}

type Props = {
  getRequestsData: () => Promise<any>;
  onLinkRequest?: (requestId: number) => Promise<void>;
  // onUpdateStudentDetails: (
  //   studentInfo: StudentForm,
  //   requestId: string
  // ) => Promise<void>;
  onUpdateStudentDetails: any;
  onClose: () => void;
};

const Component = ({
  getRequestsData,
  onClose,
  onLinkRequest,
  onUpdateStudentDetails,
}: Props) => {
  return (
    <AdminBookingUpdate
      getRequestsData={getRequestsData}
      linkRequest={onLinkRequest}
      updateStudentDetails={onUpdateStudentDetails}
      // onClose={onClose}
    />
  );
};

type Payload = {
  order: string;
};

export function linkRequestModal(
  payload: Payload,
  id: string,
  urls: {},
  callback: (...args: any[]) => void
) {
  const {} = payload;

  function onClose() {
    unMountLinkRequestModal(id);
  }

  async function getRequestsData() {
    const response = await fetch(`/admin/booking/requests/${payload.order}/`);
    try {
      const data = await response.json();
      if (response.status < 400) {
        console.log("data", data.data);
        return data.data;
      }
      throw new Error(data.errors);
    } catch (e) {
      throw e;
    }
  }

  async function onLinkRequest(requestId: number) {
    const response = await fetch(
      `/admin/booking/link/${payload.order}/${requestId}/`
    );
    try {
      const data = await response.json();
      if (response.status < 400) {
        console.log("data", data.data);
        return data.data;
      }
      throw new Error(data.errors);
    } catch (e) {
      throw e;
    }
  }

  async function onUpdateStudentDetails(
    studentInfo: StudentForm,
    requestId: string,
    studentIndex: number
  ) {
    try {
      const response = await fetch(`/admin/booking/save-student-details/`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          student: studentInfo,
          booking: payload.order,
          request_id: requestId,
          student_index: studentIndex,
        }),
      });
      const data = await response.json();
      if (response.status < 400) {
        console.log("data", data.data);
        return data.data;
      }
      throw new Error(data.errors);
    } catch (e) {
      throw e;
    }
  }

  ReactDOM.render(
    <ThemeProvider>
      <Component
        {...{
          getRequestsData,
          onLinkRequest,
          onUpdateStudentDetails,
          onClose,
        }}
      />
    </ThemeProvider>,
    document.getElementById(id)
  );
}
